module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/40ca532104bc6d54c6c1e872ba571cfd.png";